@if (loading) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
